import React, { Component } from 'react';
import { CommonlyHeadMembers } from '../../common/headnav';
import { WingBlank, WhiteSpace, Tag, Button, Toast,Modal } from 'antd-mobile';
import { Link } from "react-router-dom";
import * as services from '../../projects/services';
import * as fun from '../../../components/common';
import { AddIntegral } from "./addintegral";
import { createBrowserHistory } from "history";
import './style.less';
const history = createBrowserHistory();
let fisrtshow = false;
let page = 1;
let rows = 10;
let total = 0;
export default class Integral extends Component {
    constructor(props) {
        super(props);
        this.state = {
            parameter: { page: 1, rows: 10 },
            bindcard: [],
            dic: [],
            total:total,
            modal1:false
        }
    }
    componentDidMount() {
    
        page=1;
        fisrtshow=true;
        const { parameter } = this.state;
        services.GetUserCardList(parameter, '正在查询，请稍后').then(data => {
            if (data.status === 0) {
                let cardlist = data.result.rows;
                total=data.result.total;
                this.setState(
                    { bindcard: cardlist ,total:data.result.total},
                    () => {
                    }
                );
            } else {
                Toast.offline(data.message);
            }
        })
        const wrapper = this.refs.wrapper;
        const loadMoreDataFn = this.loadMoreDataFn;
        let timeCount;
        function callback() {
            const top = wrapper.getBoundingClientRect().top;
            const windowHeight = window.screen.height;
            if (top && top < windowHeight + 1 && total/rows >= page) {
                page++;
                loadMoreDataFn(page);
            }
        }
        window.addEventListener('scroll', function () {
            if (this.state.isLoadingMore) {
                return;
            }
            if (timeCount) {
                clearTimeout(timeCount);
            }
            timeCount = setTimeout(callback, 50);
        }.bind(this), false);

    }
    //再次加载
    loadMoreDataFn = (page) => {
        let parameter = this.state.parameter;
        parameter.page = page;
        this.setState({
            parameter: parameter,
        });
        services.GetUserCardList(parameter, '正在查询，请稍后').then(data => {
            if (data.status === 0) {
                let cardlist = data.result.rows;
                total=data.result.total;
                this.setState(
                    { bindcard: this.state.bindcard.concat(cardlist) ,total:data.result.total},
                    () => {
                    }
                );
            } else {
                Toast.offline(data.message);
            }
        })
    }
    colortype = (type) => {
        if (parseInt(type) === 0) {
            return 'b';
        } else if (parseInt(type) === 2) {
            return 'gy';
        } else {
            return 'r';
        }
    }
    onload =() =>
    {
        let parameter=this.state.parameter;
        parameter.page=1;
        this.GetUserCardList(parameter);  
    }
    onClose = () => {         
        this.setState({
            modal1: false,
        });
    }
    onAdd = (e) => {
        this.setState({
            modal1: true
        });
    }
    GetUserCardList = (parameter) =>
    {
        services.GetUserCardList(parameter, '正在查询，请稍后').then(data => {
            if (data.status === 0) {
                let cardlist = data.result.rows;
                total=data.result.total;
                this.setState(
                    { bindcard: cardlist ,total:data.result.total},
                    () => {
                    }
                );
            } else {
                Toast.offline(data.message);
            }
        })
    }
    render() {
       
        const { bindcard } = this.state;
        return <div className="integral">
            <CommonlyHeadMembers barname="健康积分" />
            <WingBlank size="lg">
                {
                    bindcard.length <= 0 && fisrtshow ?
                        <div className="errordiv"><img alt='' src={require('../../../res/images/zwsj.png')} />
                            <p>对不起，您还没有健康积分</p>
                        </div>
                        :
                        bindcard.map((data, index) => (
                            <div key={index}>
                                <WhiteSpace size="lg" />
                                <div className="integralbox" >
                                    <div className="integral-title">
                                        编号：{data.cardCode}
                                    </div>
                                    <div className="integral-cen" >
                                        <div className="cen-box">
                                            <div className="cen-a"><span>{data.cardMoney}</span><span>积分</span><Tag className={this.colortype(data.cardStatus)} >{data.cardStatusName}</Tag></div>
                                            <div className="cen-c"><span>有效期：{fun.FormatTimestr(data.createTime, 'YYYY-MM-dd')}至{fun.FormatTimestr(data.cardExpiredDate, 'YYYY-MM-dd')}</span></div>
                                            {
                                                   !!data.isDestination === false ?
                                                   <div className="cen-c">使用范围：通用</div>
                                                   :
                                                   <div className="cen-c">使用范围：<Link to={`/members/integralSyfw/`+data.publicId}>指定体检中心</Link></div>
                                               }
                                        </div>
                                        <div className="cen-but">
                                            <Button className="cenbut" onClick={
                                                () => {
                                                    history.push(`/members/integralD/${data.publicId}`);
                                                    history.go();
                                                }
                                            } >查看详情</Button>
                                            {
                                                parseInt(data.cardStatus) === 0 ?
                                                <Button className="cenbut" onClick={
                                                    () => {
                                                        localStorage.removeItem('orderment');
                                                        localStorage.removeItem('peopleId');
                                                        history.push(`/members/orderment/add/${data.publicId}/0/null`);
                                                        history.go();
                                                    }
                                                } >立即预约</Button>
                                                    : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                }
                <WhiteSpace size="lg" />
                {total === 0 && fisrtshow === false ?
                    <div className="errordiv"><img alt='' src={require('../../../res/images/zwsj.png')} />
                        <p>暂无数据</p>
                    </div>
                    : ''}
                <div ref="wrapper"></div>
            </WingBlank>
            <WhiteSpace size="lg" />
            <WhiteSpace size="lg" />
            <WhiteSpace size="lg" />
            <div className="footer">
                <div className="footerbox">
                    <Button className="inline-addbut" onClick={this.onAdd}>添加健康积分</Button>
                </div>
            </div>
            <Modal
                className="addintegral"
                visible={this.state.modal1}
                transparent
                closable={true}
                maskClosable={true}
                onClose={this.onClose}
                wrapProps={{ onTouchStart: this.onWrapTouchStart }}
            ><AddIntegral onClose={this.onClose} onload={this.onload}  />
            </Modal>
        </div>;
    }
}